import api from "@/services/api";
import { useQuery } from "@tanstack/react-query";

interface DashboardFilters {
  startDate?: string;
  endDate?: string;
  categoryId?: string;
}

export const useGetKPISData = (filters?: DashboardFilters) => {
  return useQuery({
    queryKey: ["getKPISData", filters],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (filters?.startDate) params.append("startDate", filters.startDate);
      if (filters?.endDate) params.append("endDate", filters.endDate);
      if (filters?.categoryId) params.append("categoryId", filters.categoryId);

      const response = await api.get(`/dashboard/kpis?${params.toString()}`);

      return response.data;
    },
  });
};

export const useGetOccurrencesByCategory = (
  filters?: Omit<DashboardFilters, "categoryId">,
) => {
  return useQuery({
    queryKey: ["getOccurrencesByCategory", filters],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (filters?.startDate) params.append("startDate", filters.startDate);
      if (filters?.endDate) params.append("endDate", filters.endDate);

      const response = await api.get(
        `/dashboard/occurrences-by-category?${params.toString()}`,
      );

      return response.data;
    },
  });
};

export const useGetWeeklyOccurrences = (filters?: DashboardFilters) => {
  return useQuery({
    queryKey: ["getWeeklyOccurrences", filters],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (filters?.startDate) params.append("startDate", filters.startDate);
      if (filters?.endDate) params.append("endDate", filters.endDate);
      if (filters?.categoryId) params.append("categoryId", filters.categoryId);

      const response = await api.get(
        `/dashboard/weekly-occurrences?${params.toString()}`,
      );

      return response.data;
    },
  });
};

export const useGetOccurrencesHeatmapData = (filters?: DashboardFilters) => {
  return useQuery({
    queryKey: ["getOccurrencesHeatmapData", filters],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (filters?.startDate) params.append("startDate", filters.startDate);
      if (filters?.endDate) params.append("endDate", filters.endDate);
      if (filters?.categoryId) params.append("categoryId", filters.categoryId);

      const response = await api.get(`/dashboard/heatmap?${params.toString()}`);

      return response.data;
    },
  });
};
